import { render, staticRenderFns } from "./TimezoneStaleNotice.vue?vue&type=template&id=381f9f52&"
import script from "./TimezoneStaleNotice.vue?vue&type=script&lang=js&"
export * from "./TimezoneStaleNotice.vue?vue&type=script&lang=js&"
import style0 from "./TimezoneStaleNotice.vue?vue&type=style&index=0&id=381f9f52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports